import React from 'react'

import {
  ReportingFilters,
  type ReportingFiltersProps,
} from './ReportingFilters'

type NumberComparisonFiltersProps = Omit<
  ReportingFiltersProps,
  'titleKey' | 'titleFallback' | 'subtitleKey' | 'subtitleFallback'
>

export const NumberComparisonFilters = (
  props: NumberComparisonFiltersProps,
) => (
  <ReportingFilters
    titleKey="numberComparisonFilters.numberComparison"
    titleFallback="Number Comparison"
    subtitleKey="numberComparisonFilters.subtitle"
    subtitleFallback="Compare inbound call volume across phone numbers"
    {...props}
  />
)
